export const promotionMetaByName = {
  "Бесплатный монтаж": {
    //key: "free-installation",
    key: `${encodeURIComponent('Бесплатный монтаж')}=${encodeURIComponent('1')}`,    
    image: "free-installation.jpg",
    description: "При покупке сплит-системы — монтаж за наш счёт!"
  },
  "Скидка на монтаж, %": {
    key: `${encodeURIComponent('Скидка на монтаж, %')}=${encodeURIComponent('30')}`,
    image: "install-discount.jpg",
    description: "Сэкономьте до 30% на установке при заказе через сайт."
  },
  "Товары со скидкой": { // если появится
    key: `${encodeURIComponent('Товары со скидкой')}=${encodeURIComponent('true')}`,
    image: "discount.jpg",
    description: "Выбирайте из ассортимента кондиционеров по сниженным ценам."
  }
};


//${encodeURIComponent('Тип компрессора')}=${encodeURIComponent('Да')}`} variant="dark" className="rounded-4 align-items-center me-2 mb-2"

/*export const promotions = [
  {
    id: 1,
    key: 'discount',
    title: 'Товары со скидкой',
    description: 'Выбирайте из ассортимента кондиционеров по сниженным ценам.',
    image: 'discount.jpg',
  },
  {
    id: 2,
    key: 'free-installation',
    title: 'Бесплатный монтаж',
    description: 'При покупке сплит-системы — монтаж за наш счёт!',
    image: 'free-installation.jpg',
  },
  {
    id: 3,
    key: 'install-discount',
    title: 'Скидка на монтаж',
    description: 'Сэкономьте до 30% на установке при заказе через сайт.',
    image: 'install-discount.jpg',
  },
];

export const filterProductsByPromotionKey = (products, promotionKey) => {
  switch (promotionKey) {
    case 'discount':
      return products.filter(p => p.isSale);
    case 'free-installation':
      return products.filter(p => p.freeInstall);
    case 'install-discount':
      return products.filter(p =>
        Array.isArray(p.attributes) &&
        p.attributes.some(attr =>
          attr.name?.toLowerCase().includes("скидка на монтаж")
        )
      );
    default:
      return products;
  }
};*/